import { createRoot } from "react-dom/client";

import "./index.css";
import { AppProviders } from "./providers/AppProvider.tsx";

/**
 * Routes are code-split via React.lazy (see routes/index.tsx). Each lazy
 * chunk's JS/CSS filename is content-hashed by Vite and deleted on every
 * new deploy. A tab left open since before a deploy still has the OLD
 * index-*.js loaded — navigating to a route it hasn't fetched yet tries to
 * preload a chunk by its old hash, which 404s ("Unable to preload CSS for
 * ..."). Vite emits this event specifically for that case; reloading picks
 * up the current index.html and current asset hashes instead of leaving
 * the user stuck on a broken lazy import.
 */
window.addEventListener("vite:preloadError", () => {
  window.location.reload();
});

createRoot(document.getElementById("root")!).render(<AppProviders />);
